import { type IframeAdapter } from '../../platform/iframe/IframeAdapter';

export function initIframeResizeReporter(element: HTMLElement, iframe: IframeAdapter): () => void {
  if (!iframe.isEmbedded()) return () => {};

  let lastWidth = 0;
  let lastHeight = 0;

  const postSize = () => {
    const width = element.scrollWidth;
    const height = element.scrollHeight;

    const hasWidthChanged = Boolean(width - lastWidth);
    const hasHeightChanged = Boolean(height - lastHeight);

    if (!hasWidthChanged && !hasHeightChanged) {
      return;
    }

    lastWidth = width;
    lastHeight = height;

    iframe.postToParent({ event: 'resize', width, height });
  };

  const stop = iframe.observeResize(element, postSize);
  postSize();

  return stop;
}
